module.exports = __webpack_public_path__ + "static/media/angry.47d37bb4.svg";